import { useEffect, useState } from 'react';

// Client-side deadline avoids clock skew and stale closure issues
export function useCountdown(endsAtMs: number | null): number {
  const calc = () => (endsAtMs ? Math.max(0, Math.floor((endsAtMs - Date.now()) / 1000)) : 0);

  const [remaining, setRemaining] = useState(calc);

  useEffect(() => {
    setRemaining(calc());
    const id = setInterval(() => setRemaining(calc()), 200);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endsAtMs]);

  return remaining;
}
